// extracted by mini-css-extract-plugin
module.exports = {"landingEuroContainer":"landingEuro_landingEuroContainer__3rfP0"};